<template>
  <vs-row>
    <vs-col v-if="Number(projectId) === 2" class="w-full pb-4 text-sm text-grey">
      <p>현재 월은 오늘 기준 계약 중 인원, 과거 월·연간은 해당 기간의 재직 인원입니다. 올해 연간은 오늘까지 집계합니다.</p>
      <p>전체·부서 인원은 문서당 한 번 집계하며, 사업장별 인원은 중복 소속을 포함합니다.</p>
    </vs-col>
    <!-- 그래프 1 -->
    <vs-col class="w-full pb-4">
      <monthly-chart-card :title="graph1.title" :year="graph1.year" :data1="graph1.data1" :sum1="graph1.sum1" :data2="graph1.data2" :sum2="graph1.sum2" @change="yearChangeForGraph1" />
    </vs-col>

    <div class="w-full grid grid-cols-1 lg:grid-cols-2 gap-x-2 gap-y-4 mb-4">
      <!-- 그래프 2-->
      <vs-col>
        <monthly-comparison-card :title="graph2.title" :year="graph2.year" :month="graph2.month" :has0-month="true" :unit="graph2.unit" :heads="graph2.heads" :list="graph2.list" :getCol="getColForGraph2" @change="dateChangeForGraph2">
          <template v-if="projectId" slot="tools" :set="(lv = getLevel)">
            <vs-button
              v-for="(button, idx) in getButtons"
              :key="idx"
              class="py-3 px-0 lg:px-8"
              type="border"
              :color="button.dataType === graph2.dataType ? 'primary' : 'secondary'"
              @click="dataTypeChangeForGraph2(button.dataType, button.label)"
              >{{ button.label }}</vs-button
            >
          </template>
        </monthly-comparison-card>
      </vs-col>

      <!-- 그래프 3 -->
      <vs-col>
        <daily-comparison-card dateType="yyyy-mm" :title="graph3.title" :unit="graph3.unit" :year="graph3.year" :month="graph3.month" :list="graph3.list" @change="dateChangeForGraph3">
          <template v-if="projectId" slot="tools" :set="(lv = getLevel)">
            <vs-button v-for="(button, idx) in getButtons" :key="idx" class="py-3 px-0 lg:px-8" type="border" :color="button.dataType === graph3.dataType ? 'primary' : 'secondary'" @click="dataTypeChangeForGraph3(button.dataType)">{{
              button.label
            }}</vs-button>
          </template>
        </daily-comparison-card>
      </vs-col>
    </div>

    <!-- 그래프 4-->
    <vs-col v-if="false" class="w-full pb-4">
      <monthly-comparison-card :title="graph4.title" :year="graph4.year" :month="graph4.month" :unit="graph4.unit" :heads="graph4.heads" :list="graph4.list" :getCol="getColForGraph4" @change="dateChangeForGraph4">
        <template slot="tools">
          <div>
            <vs-select class="w-full lg:w-48" autocomplete v-model="graph4.dataType1" @change="dataType1ChangeForGraph4">
              <vs-select-item value="부서" text="부서별" />
              <vs-select-item value="사업장" text="사업장별" />
            </vs-select>
          </div>
          <vs-button class="py-3 px-0 lg:px-8" type="border" :color="graph4.dataType2 === '구분' ? 'primary' : 'secondary'" @click="dataType2ChangeForGraph4('구분')">구분</vs-button>
          <vs-button class="py-3 px-0 lg:px-8" type="border" :color="graph4.dataType2 === '구분_직종' ? 'primary' : 'secondary'" @click="dataType2ChangeForGraph4('구분_직종')">구분+직종</vs-button>
        </template>
      </monthly-comparison-card>
    </vs-col>
  </vs-row>
</template>

<script>
/* eslint-disable brace-style */
import MonthlyChartCard from "@/views/graph-detail/components/MonthlyChartCard";
import MonthlyChartCard2 from "@/views/graph-detail/components/MonthlyChartCard2";
import MonthlyComparisonCard from "@/views/graph-detail/components/MonthlyComparisonCard";
import DailyComparisonCard from "@/views/graph-detail/components/DailyComparisonCard";
import tabItems from "@/views/boards/tab/tab-items";
import { createEmployeeStatisticsSource, employeeReferenceDate } from "@/util/employee/employeeDocuments";

export default {
  name: "GraphDetail02",
  components: {
    DailyComparisonCard,
    MonthlyComparisonCard,
    MonthlyChartCard2,
    MonthlyChartCard,
  },
  props: {
    comGroupList: Object,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    graphId() {
      return Number(this.$route.params.graphId);
    },
    isApproval() {
      return tabItems[358].isApproval;
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const project of projects) {
          if (`${project.id}` === `${this.projectId}` && project.company.length > 0) {
            const path = project.company[0].pivot.company_path;
            return path.split("/").length - 1; // LEVEL
          }
        }
      }
      return 4;
    },
    getButtons() {
      return [
        { label: "부서", dataType: "부서" },
        { label: "사업장", dataType: "사업장" },
        { label: "구분", dataType: "구분" },
        { label: "직종", dataType: "직종" },
      ];
    },
  },
  data() {
    return {
      boardId: 358,
      summaryKey: ["종사자_직종", "sum"],
      boardIds: [299, 358],
      summaryKeys: {
        detail: ["종사자현황_구분", "sum"],
        detail_직종: ["종사자현황_직종", "sum"],
        field: ["종사자현황_사업장", "sum"],
        address: ["종사자현황_부서", "sum"],
        field_cat1: ["종사자현황_부서", "sum"],
        company: ["종사자현황_부서", "sum"],
        project: ["종사자현황_부서", "sum"],
      },
      buttons: [
        { label: "부서(업체)", dataType: "company" },
        { label: "사업장", dataType: "field" },
        { label: "종사자 구분", dataType: "detail" },
        { label: "직종", dataType: "detail_직종" },
      ],
      graph1: {
        title: "종사자 현황",
        year: new Date().getFullYear(),
        data1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 선택한 년도
        data2: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 선택한 년도의 이전 년도
      },
      graph2: {
        title: "월별 종사자 인원 현황",
        year: new Date().getFullYear(),
        month: Number(this.$route.params.proj_id) === 2 ? new Date().getMonth() + 1 : 0,
        unit: "",
        heads: [{ name: "No." }, { name: "부서(업체)" }, { name: "명" }, { name: "전월대비 증감" }],
        list: [],
        summaryKey1: "",
        dataType: "company1",
        depth: 1,
      },
      graph3: {
        title: "기간별 종사자 인원 현황",
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        unit: "명",
        list: [],
        dataType: "company",
        depth: 1,
      },
      graph4: {
        title: "상세 내부종사자 현황",
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        unit: "",
        heads: [{ name: "No." }, { name: "부서명" }, { name: "구분" }, { name: "명" }, { name: "전월대비 증감" }],
        list: [],
        summaryKey1: "",
        dataType1: "부서",
        dataType2: "구분",
      },
      employeeSource: null,
      employeeSourceKey: "",
      cache: {},
      dataPromises: {},
      loading: false,
    };
  },
  async mounted() {
    await this.loadDetailData();

    this.graph2.dataType = this.getButtons[0].dataType;
    this.graph3.dataType = this.getButtons[0].dataType;
    this.dataTypeChangeForGraph2(this.getButtons[0].dataType, this.getButtons[0].label);

    await this.loadGraph1();
    await this.loadGraph2();
    await this.loadGraph3();
    // 숨겨진 구형 그래프는 현재 집계 데이터 구조를 지원하지 않는다.
    if (Number(this.projectId) !== 2) await this.loadGraph4();
  },

  methods: {
    // API에서 상세 정보를 불러온다
    async loadDetailData(currentYear) {
      if (Number(this.projectId) === 2) {
        const now = new Date();
        const key = `${this.projectId}_${employeeReferenceDate(now)}`;
        if (this.employeeSourceKey !== key) {
          this.employeeSource = createEmployeeStatisticsSource(this.projectId, now);
          this.employeeSourceKey = key;
        }
        return this.employeeSource.loadYear(currentYear || now.getFullYear());
      }

      if (!currentYear) {
        currentYear = new Date().getFullYear();
      }

      // 캐시에 저장되어 있으면 바로 반환
      const cacheKey = `data_${currentYear}`;
      if (this.cache[cacheKey]) {
        console.log(`캐시된 데이터 사용: ${cacheKey}`);
        return this.cache[cacheKey];
      }

      // 이미 진행 중인 요청이 있으면 해당 Promise 반환
      if (this.dataPromises[cacheKey]) {
        console.log(`진행 중인 API 요청 사용: ${cacheKey}`);
        return this.dataPromises[cacheKey];
      }

      // 새로운 요청 Promise 생성 및 저장
      const dataPromise = (async () => {
        try {
          const data = {
            월별: [0 /*합계*/, 0 /*1월*/, 0 /*2월*/, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            부서: [[], [], [], [], [], [], [], [], [], [], [], [], []], // 13개 배열 (합계 + 12개월)
            사업장: [[], [], [], [], [], [], [], [], [], [], [], [], []], // 13개 배열 (합계 + 12개월)
            구분: [[], [], [], [], [], [], [], [], [], [], [], [], []], // 13개 배열 (합계 + 12개월)
            직종: [[], [], [], [], [], [], [], [], [], [], [], [], []], // 13개 배열 (합계 + 12개월)
          };
          const temp부서 = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
          const temp사업장 = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
          const temp구분 = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
          const temp직종 = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];

          const payload = {
            projectId: this.projectId,
            page: 1,
            perPage: 10000,
            to_retirement_date: `${currentYear}-12-31`,
          };
          const response = await this.$store.dispatch("employee/LOAD_EMPLOYEE_LIST", payload);

          const incrementCount = (target, index, key) => {
            if (!target[index][key]) {
              target[index][key] = 1;
            } else {
              target[index][key]++;
            }
          };
          data.월별[0] = response.data.length;


          response.data.forEach((item) => {
            const hasRetireDate = !!item.retirement_date;
            const hireDate = item.hire_date ? new Date(item.hire_date) : null;
            const retireDate = hasRetireDate ? new Date(item.retirement_date) : new Date(`${currentYear}-12-31`);

            let fromMonth = 1;
            let toMonth = 12;

            if (hireDate && retireDate instanceof Date && !isNaN(hireDate) && !isNaN(retireDate)) {
              const hireYear = hireDate.getFullYear();
              const retireYear = retireDate.getFullYear();

              fromMonth = hireYear < currentYear ? 1 : hireYear > currentYear ? 13 : hireDate.getMonth() + 1;
              toMonth = retireYear < currentYear ? 0 : retireDate.getMonth() + 1;
            }

            let shouldCountTotal = true;


            // fromMonth가 toMonth보다 크면 루프 돌리지 않음
            for (let i = fromMonth; i <= toMonth; i++) {
              data.월별[i]++;

              item.fields.forEach((field) => {
                // ========== 부서 ==========
                const comNameEntry = field.meta_info.find((item) => item.meta_key === "com_name");
                const comName = comNameEntry ? comNameEntry.meta_value : null;

                if (comName) incrementCount(temp부서, i, comName);

                // ========== 사업장 ==========
                incrementCount(temp사업장, i, field.field_name);

                if (shouldCountTotal) {
                  // ========== 부서 총계 ==========
                  incrementCount(temp부서, 0, comName);

                  // ========== 사업장 총계 ==========
                  incrementCount(temp사업장, 0, field.field_name);
                }
              });

              // ========== 구분 ==========
              incrementCount(temp구분, i, item.job_category);

              // ========= 직종 ===========
              incrementCount(temp직종, i, item.employment_type);

              shouldCountTotal = false;
            }

            // ========== 구분 총계 ==========
            incrementCount(temp구분, 0, item.job_category);

            // ========== 직종 총계 ==========
            incrementCount(temp직종, 0, item.employment_type);
          });


          // Temp데이터를 그래프에서 사용가능하도록 데이터 구조 변경

          const mapToLabelValueArray = (objArray) => {
            return objArray.map((obj) => Object.entries(obj).map(([label, value]) => ({ label, value })));
          };

          data.부서 = mapToLabelValueArray(temp부서);
          data.사업장 = mapToLabelValueArray(temp사업장);
          data.구분 = mapToLabelValueArray(temp구분);
          data.직종 = mapToLabelValueArray(temp직종);

          // 캐시에 결과 저장
          this.cache[cacheKey] = data;
          return data;
        } finally {
          // 요청 완료 후 진행 중인 Promise 객체 삭제
          delete this.dataPromises[cacheKey];
        }
      })();

      // 진행 중인 요청 Promise 저장
      this.dataPromises[cacheKey] = dataPromise;

      // Promise 반환
      return dataPromise;
    },

    // 그래프 1
    async loadGraph1() {
      const currentYear = this.graph1.year;
      const currentYearData = JSON.parse(JSON.stringify(await this.loadDetailData(currentYear)));
      const currentMonthlyData = currentYearData.월별 || [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      const currentYearSum = currentMonthlyData[0];
      currentMonthlyData.shift();

      const lastYear = currentYear - 1;
      const lastYearData = JSON.parse(JSON.stringify(await this.loadDetailData(lastYear)));
      const lastMonthlyData = lastYearData.월별 || [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      const lastYearSum = lastMonthlyData[0];
      lastMonthlyData.shift();

      this.graph1.data1 = currentMonthlyData;
      this.graph1.data2 = lastMonthlyData;
      this.graph1.sum1 = `${currentYearSum}`;
      this.graph1.sum2 = `${lastYearSum}`;
    },
    yearChangeForGraph1(year) {
      this.graph1.year = year;
      this.loadGraph1();
    },

    // 그래프 2
    async loadGraph2() {
      const currentYear = this.graph2.year;
      const prevYear = currentYear - 1;

      const currentYearData = await this.loadDetailData(currentYear);
      const prevYearData = await this.loadDetailData(prevYear);

      let currentYearGraph2Data = [];
      let prevYearGraph2Data = [];
      switch (this.graph2.dataType) {
        case "부서":
          currentYearGraph2Data = currentYearData.부서;
          prevYearGraph2Data = prevYearData.부서;
          break;
        case "사업장":
          currentYearGraph2Data = currentYearData.사업장;
          prevYearGraph2Data = prevYearData.사업장;
          break;
        case "구분":
          currentYearGraph2Data = currentYearData.구분;
          prevYearGraph2Data = prevYearData.구분;
          break;
        case "직종":
          currentYearGraph2Data = currentYearData.직종;
          prevYearGraph2Data = prevYearData.직종;
          break;
      }

      const currentMonth = this.graph2.month;

      let prevMonth = 0;
      let prevDataSet = null;
      if (currentMonth === 0) {
        prevMonth = 0;
        prevDataSet = prevYearGraph2Data;
      } else if (currentMonth === 1) {
        prevMonth = 12;
        prevDataSet = prevYearGraph2Data;
      } else {
        prevMonth = currentMonth - 1;
        prevDataSet = currentYearGraph2Data;
      }

      const currentData = currentYearGraph2Data[currentMonth];
      const prevData = prevDataSet[prevMonth];

      const list = [];
      let no = 1;

      for (const row of currentData) {
        const prevRow = prevData.find((item) => item.label === row.label);
        const gap = prevRow ? row.value - prevRow.value : row.value;
        list.push({
          no,
          name: row.label,
          value: row.value,
          gap,
        });
        no += 1;
      }

      // prevData 중에서 list에 포함되지 않은 데이터를 찾아서 추가한다
      for (const row of prevData) {
        const currentRow = currentData.find((item) => item.label === row.label);
        if (!currentRow) {
          list.push({
            no,
            name: row.label,
            value: 0,
            gap: -row.value,
          });
          no += 1;
        }
      }

      // list 데이터를 value 기준으로 내림차순 정렬
      list.sort((a, b) => b.value - a.value);

      this.graph2.list = list;
    },

    getColForGraph2(index, value) {
      if (index === 0) return value.no;
      if (index === 1) return value.name;
      if (index === 2) {
        return new Intl.NumberFormat().format(value.value);
      }
      if (index === 3) {
        let updown = "default";
        if (value.gap > 0) updown = "up";
        else if (value.gap < 0) updown = "down";
        return { type: updown, value: new Intl.NumberFormat().format(value.gap) };
      }
      return "";
    },
    dateChangeForGraph2(year, month) {
      this.graph2.year = year;
      this.graph2.month = month;
      this.loadGraph2();
    },
    dataTypeChangeForGraph2(dataType, label) {
      this.graph2.heads[1].name = label;
      if (this.projectId) {
        this.graph2.dataType = dataType;
        if (dataType === "company1") {
          this.graph2.depth = 1;
        } else if (dataType === "company2") {
          this.graph2.depth = 2;
        } else {
          this.graph2.depth = 1;
        }
        this.loadGraph2();
      }
    },

    // 그래프 3
    async loadGraph3() {
      const currentYear = this.graph3.year;
      const currentMonth = this.graph3.month;

      const currentYearData = await this.loadDetailData(currentYear);

      let graph3Data = [];
      switch (this.graph3.dataType) {
        case "부서":
          graph3Data = currentYearData.부서;
          break;
        case "사업장":
          graph3Data = currentYearData.사업장;
          break;
        case "구분":
          graph3Data = currentYearData.구분;
          break;
        case "직종":
          graph3Data = currentYearData.직종;
          break;
        default:
          return;
      }

      const currentData = graph3Data[currentMonth];

      const list = [];

      for (const row of currentData) {
        list.push({
          label: row.label,
          value: row.value,
        });
      }

      // list 데이터를 value 기준으로 내림차순 정렬
      list.sort((a, b) => b.value - a.value);

      this.graph3.list = list;
    },

    dateChangeForGraph3(year, month) {
      this.graph3.year = year;
      this.graph3.month = month;
      this.loadGraph3();
    },
    dataTypeChangeForGraph3(dataType) {
      if (this.projectId) {
        this.graph3.dataType = dataType;
        if (dataType === "company1") {
          this.graph3.depth = 1;
        } else if (dataType === "company2") {
          this.graph3.depth = 2;
        } else {
          this.graph3.depth = 1;
        }

        this.graph3.dataType = dataType;
        this.loadGraph3();
      }
    },

    // 그래프 4
    async loadGraph4() {
      const yyyy = this.graph4.year;
      const depth = this.graph4.depth;

      const data = await this.loadDetailData(yyyy, depth);
      let graph4Data = [];
      switch (this.graph4.dataType1) {
        case "부서":
          if (this.graph4.dataType2 === "구분") {
            graph4Data = data.company_employee;
          } else {
            graph4Data = data.company_employee_job_title;
          }
          break;
        case "사업장":
          if (this.graph4.dataType2 === "구분") {
            graph4Data = data.field_employee;
          } else {
            graph4Data = data.field_employee_job_title;
          }
          break;
        default:
          return;
      }

      const currentYear = yyyy;
      const currentMonth = this.graph4.month;
      const prevYear = currentMonth === 1 ? currentYear - 1 : currentYear;
      const prevMonth = currentMonth === 1 ? 12 : currentMonth - 1;

      const currentData = graph4Data[currentYear][currentMonth];
      const prevData = graph4Data[prevYear][prevMonth];

      const list = [];
      let no = 1;

      for (const row of currentData) {
        const prevRow = prevData.find((item) => item.label === row.label);
        const gap = prevRow ? row.count - prevRow.count : row.count;
        list.push({
          no,
          name: row.label,
          value: row.count,
          구분: row.employee_type,
          직종: row.job_title,
          gap,
        });
        no += 1;
      }

      // prevData 중에서 list에 포함되지 않은 데이터를 찾아서 추가한다
      for (const row of prevData) {
        const currentRow = currentData.find((item) => item.label === row.label);
        if (!currentRow) {
          list.push({
            no,
            name: row.label,
            value: 0,
            gap: -row.count,
            구분: row.employee_type,
            직종: row.job_title,
          });
          no += 1;
        }
      }

      this.graph4.list = list;
    },

    getColForGraph4(index, value) {
      if (this.graph4.dataType2 === "구분") {
        if (index === 0) return value.no;
        if (index === 1) return value.name;
        if (index === 2) return value.구분;
        if (index === 3) return value.value;
        if (index === 4) {
          let updown = "default";
          if (value.gap > 0) updown = "up";
          else if (value.gap < 0) updown = "down";
          return { type: updown, value: new Intl.NumberFormat().format(value.gap) };
        }
      }

      if (this.graph4.dataType2 === "구분_직종") {
        if (index === 0) return value.no;
        if (index === 1) return value.name;
        if (index === 2) return value.구분;
        if (index === 3) return value.직종;
        if (index === 4) return value.value;
        if (index === 5) {
          let updown = "default";
          if (value.gap > 0) updown = "up";
          else if (value.gap < 0) updown = "down";
          return { type: updown, value: new Intl.NumberFormat().format(value.gap) };
        }
      }

      return "";
    },
    dateChangeForGraph4(year, month) {
      this.graph4.year = year;
      this.graph4.month = month;
      this.loadGraph4();
    },
    dataType1ChangeForGraph4() {
      if (this.graph4.dataType2 === "구분") {
        this.graph4.heads = [{ name: "No." }, { name: this.graph4.dataType1 === "부서" ? "부서명" : "사업장명" }, { name: "구분" }, { name: "명" }, { name: "전월대비 증감" }];
      } else {
        this.graph4.heads = [{ name: "No." }, { name: this.graph4.dataType1 === "부서" ? "부서명" : "사업장명" }, { name: "구분" }, { name: "직종" }, { name: "명" }, { name: "전월대비 증감" }];
      }
      this.loadGraph4();
    },
    dataType2ChangeForGraph4(dataType) {
      this.graph4.dataType2 = dataType;
      this.dataType1ChangeForGraph4();
    },
  },
};
</script>

<style scoped></style>
